// extracted by mini-css-extract-plugin
module.exports = {"user-name":"ActivityOwner_user-name__18jAA","colored":"ActivityOwner_colored__3Lwjb"};